import { CircularProgress, Paper } from '@mui/material'

interface Props {
  isLoading: boolean
}

const PaperProgress = ({ isLoading }: Props) => {
  return isLoading ? (
    <Paper
      elevation={24}
      square
      sx={{
        position: 'absolute',
        inset: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1,
        boxShadow: 'none',
      }}
    >
      <CircularProgress />
    </Paper>
  ) : null
}

export default PaperProgress
